import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { loadFingerprintIfNeeded } from '../utils/fingerprint';
import './DesktopNavigation.css';

export default function DesktopNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { totalItems } = useCart();

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname.startsWith('/product/');
    }
    return location.pathname === path;
  };

  return (
    <nav className="desktop-navigation">
      <div className="nav-container">
        <div className="nav-brand" onClick={() => navigate('/')}>
          <span className="brand-icon">🛍️</span>
          <span className="brand-text">PinchStore</span>
        </div>
        
        <div className="nav-links">
          <button
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => navigate('/')}
          >
            Store
          </button>
          
          <button
            className={`nav-link ${isActive('/cart') ? 'active' : ''}`}
            onClick={() => {
              void loadFingerprintIfNeeded('cart-click');
              navigate('/cart');
            }}
            aria-label="Cart"
            title="Cart"
          >
            <span className="nav-icon" aria-hidden="true">
              🛒
              {totalItems > 0 && (
                <span className="nav-badge">{totalItems}</span>
              )}
            </span>
          </button>
        </div>
      </div>
    </nav>
  );
}
